import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {CookieService} from 'ngx-cookie-service';
import {AuthenticationService} from './authentication.service';

@Injectable()
export class SystemUserService {

    constructor(private httpClient: HttpClient, private cookieService: CookieService) {
    }

    static GetAllSystemUserURL(page = 1): string {
        return environment.API_ENDPOINT + '/api/system-users?page=' + page
    }

    static GetSystemUserURL(id): string {
        return environment.API_ENDPOINT + '/api/system-user/' + id;
    }

    static CreateSystemUserURL(): string {
        return environment.API_ENDPOINT + '/api/system-user';
    }

    static EditSystemUserURL(id): string {
        return environment.API_ENDPOINT + '/api/system-user/' + id;
    }

    private getHeaders() {
        let headers = new HttpHeaders();
        headers = headers.append('Accept', 'application/json');
        headers = headers.append('Authorization', 'Bearer ' + this.cookieService.get(AuthenticationService.sessionKey));
        return {headers};
    }

    getAllSystemUser(page = 1, search = null) {
        const formData: any = new FormData();
        for (const key in search) {
            if (Object.prototype.hasOwnProperty.call(search, key)) {
                formData.append(key, search[key]);
            }
        }
        return this.httpClient.post<any>(SystemUserService.GetAllSystemUserURL(page), formData, this.getHeaders());
    }

    getSystemUser(systemUserId) {
        return this.httpClient.get<any>(SystemUserService.GetSystemUserURL(systemUserId), this.getHeaders());
    }

    addSystemUser(systemUser) {
        const formData: any = new FormData();
        for (const key in systemUser) {
            if (Object.prototype.hasOwnProperty.call(systemUser, key)) {
                if (systemUser[key] != '') {
                    formData.append(key, systemUser[key]);
                }
            }
        }
        return this.httpClient.post<any>(SystemUserService.CreateSystemUserURL(), formData, this.getHeaders());
    }

    updateSystemUser(systemUserId, systemUser) {
        return this.httpClient.put<any>(SystemUserService.EditSystemUserURL(systemUserId), systemUser, this.getHeaders());
    }
}